import React from 'react';
export function Footer() {
  return <footer className="bg-base py-12" data-id="element-128">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8" data-id="element-129">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 font-mono text-[10px] tracking-widest text-ink/40" data-id="element-130">
          <div className="flex items-center gap-3" data-id="element-131">
            <span className="font-bold text-ink" data-id="element-132">DPIP</span>
            <span className="text-indigo-400" data-id="element-133">SYS</span>
            <span className="px-2 text-ink/30" data-id="element-134">{'//'}</span>
            <span data-id="element-135">END OF TRANSMISSION</span>
          </div>

          <div className="text-center md:text-left" data-id="element-136">
            POWERED BY WAYDEV. THE ALL-IN-ONE ENGINEERING INTELLIGENCE PLATFORM.
          </div>

          <div className="flex gap-6" data-id="element-137">
            <a href="#" className="hover:text-lime transition-colors" data-id="element-138">
              [ SUBMIT_CORRECTION ]
            </a>
            <a href="#" className="hover:text-lime transition-colors" data-id="element-139">
              [ TWITTER ]
            </a>
            <a href="#" className="hover:text-lime transition-colors" data-id="element-140">
              [ GITHUB ]
            </a>
          </div>
        </div>
      </div>
    </footer>;
}